import * as React from "react";
import CommitteesMemberGroup from "./committees-member-group";
import Heading from "atoms/typography/heading";
import { HeadingPriority } from "atoms/constants/heading-priority";

export interface CommitteesAlternatesMemberGroupProps {
    children?: JSX.Element[];
}

const CommitteesAlternatesMemberGroup = (
    props: CommitteesAlternatesMemberGroupProps
) => {
    return (
        <CommitteesMemberGroup>
            <React.Fragment>
                <Heading
                    priority={HeadingPriority.Three}
                    cssClassName="c-committee-member-group__title">
                    Alternates
                </Heading>
                {props.children}
            </React.Fragment>
        </CommitteesMemberGroup>
    );
};

export default CommitteesAlternatesMemberGroup;
